import CrossIcon from 'assets/svgr-icons/Close.svg'

import * as Styled from './styled'

interface IProps {
  onRemoveClick: () => void
  isStaticView: boolean
}

export const InputRemoveButton: React.FC<IProps> = props => {
  const { onRemoveClick, isStaticView } = props
  return (
    <Styled.CrossIcon
      $isStaticView={isStaticView}
      initial={{ opacity: 0, x: '100%' }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: '100%' }}
      transition={{ duration: 0.2, type: 'spring', stiffness: 150 }}
      onClick={onRemoveClick}
    >
      <CrossIcon />
    </Styled.CrossIcon>
  )
}
